import { Layout, Typography } from 'antd';

const { Footer } = Layout;
const { Text } = Typography;

const AppFooter = () => {
    return (
        <Footer className='appFooter'>
            <Text> ELECTROLUX © {new Date().getFullYear()}</Text>
        </Footer>
    );
}
export default AppFooter;